var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[("icon icon-" + _vm.icon), _vm.$attrs.class]},[_c('use',{attrs:{"href":("/svg/sprite.symbol.svg?v1#" + _vm.icon),"xlink:href":("./svg/sprite.symbol.svg?v1#" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }